import { useState, useEffect } from "react";
import type { MacCpuArch, OS, WindowsCpuArch } from "@/lib/platform";
import {
  detectMacCpuArch,
  detectWindowsCpuArch,
} from "@/lib/user-agent-detect";

export function useOS() {
  const [os, setOs] = useState<OS>(() => {
    const saved = localStorage.getItem("proxdav-os");
    return saved === "windows" || saved === "macos" ? saved : "unknown";
  });

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    let detected: OS = "unknown";
    if (userAgent.indexOf("win") !== -1) {
      detected = "windows";
    } else if (userAgent.indexOf("mac") !== -1) {
      detected = "macos";
    }

    if (detected !== "unknown") {
      setOs(detected);
      localStorage.setItem("proxdav-os", detected);
    }
  }, []);

  return os;
}

export function useWindowsCpuArch(os: OS): WindowsCpuArch {
  const [arch, setArch] = useState<WindowsCpuArch>("unknown");

  useEffect(() => {
    if (os !== "windows") return;

    let cancelled = false;
    detectWindowsCpuArch().then((a) => {
      if (!cancelled) setArch(a);
    });

    return () => {
      cancelled = true;
    };
  }, [os]);

  return arch;
}

export function useMacCpuArch(os: OS): MacCpuArch {
  const [arch, setArch] = useState<MacCpuArch>("unknown");

  useEffect(() => {
    if (os !== "macos") return;

    let cancelled = false;
    detectMacCpuArch().then((a) => {
      if (!cancelled) setArch(a);
    });

    return () => {
      cancelled = true;
    };
  }, [os]);

  return arch;
}
